export const LOGIN = '/login/cookie';
export const LOGOUT = '/logout';
export const SIGNUP = '/signup/cookie';
export const SAML_SIGNUP = '/saml/signup';
